var thTH = {
  locale: 'th_TH',
  direction: 'ltr',
  date: {
    defaultFormat: {
      week: 'WW/YYYY',
      date: 'DD/MM/YYYY',
      month: 'MM/YYYY',
      year: 'YYYY',
      time: 'HH:mm:ss',
      dateTime: 'DD/MM/YYYY HH:mm:ss'
    },
    startDay: 0,
    shortMonthList: ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', ' ธ.ค.'],
    monthList: ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', ' ธ.ค.'],
    shortDayList: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
    dayList: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
    shortestDayList: ['อ.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.']
  },
  'dynamic-date': {
    day: 'วัน',
    week: 'สัปดาห์',
    month: 'เดือน',
    quarter: 'ไตรมาส',
    year: 'ปี',
    before: 'ก่อน ${value}${unit}'
  },
  'auto-complete.empty': 'ไม่มีข้อมูล',
  'select.selected-count': 'เลือกแล้ว ${count} รายการ',
  'date-time-picker.date': 'เลือกวันที่',
  'image-view.zoom-out': 'ซูมออก',
  'input.placeholder': 'โปรดป้อน',
  'empty.text': 'ไม่มีข้อมูล',
  'date-picker.cancel': 'ยกเลิก',
  'date-picker.end': 'เวลาสิ้นสุด',
  'cascader.empty': 'ไม่มีข้อมูล',
  'upload.drop': 'ลากแฟ้มมาที่นี่หรือ',
  'color.custom': 'ปรับแต่งสี',
  'cascader.titles': ['ระดับ 1', 'ระดับ 2', 'ระดับ 3', 'ระดับ 4', 'ระดับ 5', 'ระดับ 6', 'ระดับ 7', 'ระดับ 8'],
  'date-comparison.error-target': 'เลือกเวลาสิ้นสุดเพื่อทำการเปรียบเทียบ',
  'transfer.empty': 'ไม่มีข้อมูล',
  'select.search.placeholder': 'โปรดป้อน',
  'upload.click': 'คลิกเพื่ออัปโหลด',
  'date-time-picker.placeholder': 'โปรดป้อน',
  'pager.jump': 'เปลี่ยนเส้นทาง',
  'tree-select.placeholder': 'โปรดป้อน',
  'dynamic-date.interval': 'ช่วงเวลา',
  'modal.cancel': 'ยกเลิก',
  'image-view.rotate': 'หมุน',
  'tabs.more': 'เพิ่มเติม',
  'popover.ok': 'ยืนยัน',
  'transfer.placeholder': 'โปรดป้อน',
  'date.month': 'เดือน',
  'select.selected': 'เลือกแล้ว',
  'popover.cancel': 'ยกเลิก',
  'image-view.prev': 'ก่อนหน้า',
  'table.emptyText': 'ไม่มีข้อมูล',
  'date-time-picker.ok': 'ยืนยัน',
  'table.filter.confirm': 'ยืนยัน',
  'tree-select.empty': 'ไม่มีข้อมูล',
  'dynamic-date.fixed-date': 'วันที่กำหนดแน่นอน',
  'date-comparison.compare': 'เปรียบเทียบ',
  'auto-complete.placeholder': 'โปรดป้อน',
  'time-picker.placeholder': 'เลือกเวลา',
  'date.month-first': false,
  'select.clear': 'ล้าง',
  'date.year': 'ปี ${year}',
  'date-comparison.yoy': 'ช่วงเวลานี้ของปีที่แล้ว',
  'image-view.zoom-to-origin': 'เดิม',
  'schedule.title': 'วันที่/เวลา',
  'schedule.clear': 'ล้าง',
  'date-time-picker.end': 'เลือกวันที่และเวลาสิ้นสุด',
  'dynamic-date.customize': 'ปรับแต่ง',
  'date-picker.apply': 'ปรับใช้',
  'schedule.selected': 'เวลาที่เลือก',
  'dynamic-date.dynamic-date': 'วันที่ที่เปลี่ยนแปลงได้',
  'select.placeholder': 'โปรดเลือก',
  'schedule.separator': ',',
  'cascader.search': 'โปรดป้อน',
  'date-picker.invalid-range': 'ช่วงเวลาที่เลือกเกินช่วงที่เลือกได้ โปรดเลือกช่วงที่ใช้ได้',
  'dynamic-date.date-preview': 'ตัวอย่างวันที่',
  'select.empty': 'ไม่มีข้อมูล',
  'image-view.next': 'ถัดไป',
  'date-time-picker.now': 'ตอนนี้',
  'date-time-picker.time': 'เลือกเวลา',
  'tree.empty': 'ไม่มีข้อมูล',
  'pager.total': 'รวมบันทึกทั้งหมด ${total} รายการ',
  'image-view.zoom-in': 'ซูมเข้า',
  'date-picker.placeholder': 'เลือกวันที่',
  'textarea.placeholder': 'โปรดป้อน',
  'date.week': 'สัปดาห์',
  'pager.size': 'บันทึก ${count} รายการ/หน้า',
  'modal.ok': 'ยืนยัน',
  'date-picker.start': 'เวลาเริ่มต้น',
  'table.filter.reset': 'รีเซ็ต',
  'image-view.zoom-to-fit': 'พอดี',
  'pager.page.placeholder': 'โปรดป้อน',
  'select.select-all': 'เลือกทั้งหมด',
  'list-viewer.empty': 'ไม่มีข้อมูล',
  'date-comparison.compare-text': 'กับ',
  'transfer.source': 'รายการแหล่งที่มา',
  'date-time-picker.start': 'เลือกวันที่และเวลาเริ่มต้น',
  'date-time-picker-panel.start': 'วันที่เริ่มต้น',
  'date-time-picker-panel.end': 'วันที่สิ้นสุด',
  'date-comparison.error-source': 'เลือกเวลาเริ่มต้นเพื่อทำการเปรียบเทียบ',
  'upload.error.overflow-count': 'ไฟล์เกินจำนวนสูงสุดแล้ว',
  'date-comparison.placeholder': 'เวลาเริ่มต้น - เวลาสิ้นสุด',
  'time-range-picker.placeholder': 'เวลาเริ่มต้น - เวลาสิ้นสุด',
  'date-comparison.mom': 'เปรียบเทียบกับช่วงเวลาก่อนหน้า',
  'transfer.target': 'รายการเป้าหมาย',
  table: {
    selectionMenu: {
      selectCurrent: 'Select Current',
      selectAll: 'Select All',
      unselectCurrent: 'Unselect Current',
      unselectAll: 'Unselect All'
    }
  }
};
export default thTH;